import { gql } from '@apollo/client'

export const GET_PRODUCTS = gql`
  query GetProducts($filters: ProductFilters) {
    products(filters: $filters) {
      id
      name
      partNumber
      description
      manufacturer
      type
      quantity
    }
  }
`

export const GET_PRODUCT = gql`
  query GetProduct($id: String!) {
    product(id: $id) {
      id
      name
      partNumber
      description
      manufacturer
      type
      quantity
    }
  }
`

// Note: These mutations and queries will need to be implemented in the backend
// For now, we'll create placeholder queries that match the expected structure
export const CREATE_PRODUCT_RELATIONSHIP = gql`
  mutation CreateProductRelationship($input: CreateProductRelationshipInput!) {
    createProductRelationship(input: $input) {
      id
      product1Id
      product2Id
      relationship
      createdAt
    }
  }
`

export const DELETE_PRODUCT_RELATIONSHIP = gql`
  mutation DeleteProductRelationship($id: String!) {
    deleteProductRelationship(id: $id) {
      id
    }
  }
`

export const GET_PRODUCT_ALTERNATES = gql`
  query GetExistingProductAlternates($productId: String!) {
    productRelationships(
      filters: { product2Id: $productId, relationship: ALTERNATE }
    ) {
      id
      product1Id
      createdAt
      product1 {
        id
        name
        partNumber
        description
        manufacturer
        type
        quantity
      }
    }
  }
`

export const GET_PRODUCTS_GIVEN_ALTERNATE = gql`
  query GetProductsGivenAlternate($productId: String!) {
    productRelationships(
      filters: { product1Id: $productId, relationship: ALTERNATE }
    ) {
      id
      product2Id
      createdAt
      product2 {
        id
        name
        partNumber
        description
        manufacturer
        type
        quantity
      }
    }
  }
`
